<template>
  <div>
    <Header />
    <div class="c-standard-content">
      <div class="c-standard-list-bx">
        <h2>立项申请</h2>
        <ul class="c-standard-list">
          <li>
            <el-steps :active="status" finish-status="success">
              <el-step :title="step" v-for="(step,index) in timelist" :key="`step${index}`"></el-step>
            </el-steps>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>标准名称： </p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="28" placeholder="标准名称" v-model="standardName">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>标准级别： </p>
            <div class="c-standard-rt-input">
              <select v-model="stdLevel">
                <option value="国际">国际</option>
                <option value="国家">国家</option>
                <option value="行业">行业</option>
                <option value="地方">地方</option>
                <option value="团体">团体</option>
              </select>
            </div>
          </li>
          <!-- <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>发起机构：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="发起机构" v-model="organization">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>负责人：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="法定代表人或标准负责人" v-model="legalPerson">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>社会统一信用代码：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="社会统一信用代码" v-model="scc">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>地址：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="地址" v-model="address">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>联系人：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="联系人" v-model="contacts">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>联系电话：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="联系电话" v-model="mobile">
            </div>
          </li> -->
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>标准类型：</p>
            <div class="c-standard-rt-input">
              <div class="price-negotiation">
                <div style="display: inline-block;"><input class="product-pricing checkbox" type="radio" name="standardT"
                    v-model="standardType" value="1" id="standardT" /><label for="male">提案</label></div>
                <div style="display: inline-block;"><input class="product-pricing checkbox" type="radio" name="standardT"
                    v-model="standardType" value="0" id="standardT2" /><label for="female">认定</label></div>
              </div>
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>是否涉及必要专利：</p>
            <div class="c-standard-rt-input">
              <div class="price-negotiation">
                <div style="display: inline-block;"><input class="product-pricing checkbox" type="radio" name="HaveZl"
                    v-model="isHaveZl" value="1" id="male" /><label for="isHaveZl">是</label></div>
                <div style="display: inline-block;"><input class="product-pricing checkbox" type="radio" name="HaveZl"
                    v-model="isHaveZl" value="0" id="female" /><label for="noHaveZl">否</label></div>
              </div>
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>技术领域：</p>
            <div class="c-standard-rt-input">
              <select v-model="industryCategory">
                <option value="新一代信息技术">新一代信息技术</option>
                <option value="高端装备制造">高端装备制造</option>
                <option value="新材料">新材料</option>
                <option value="生物">生物</option>
                <option value="新能源汽车">新能源汽车</option>
                <option value="新能源">新能源</option>
                <option value="节能环保">节能环保</option>
                <option value="数字创意">数字创意</option>
                <option value="相关服务">相关服务</option>
                <option value="其他">其他</option>
              </select>
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>主要涉及产品/服务名称：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="28" placeholder="主要涉及产品/服务名称" v-model="productsServices">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>该标准的技术创新点及先进性描述：</p>
            <div class="c-standard-rt-input">
              <textarea class="textarea" placeholder="该标准的技术创新点及先进性描述" v-model="techDescription"></textarea>
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>该标准在相关产业（产品/服务）中的应用情况及产生的效果：</p>
            <div class="c-standard-rt-input">
              <textarea class="textarea" placeholder="该标准在相关产业（产品/服务）中的应用情况及产生的效果" v-model="valueDescription"></textarea>
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>自我声明：</p>
            <div class="c-standard-rt-input">
              <textarea class="textarea" placeholder="自我声明" v-model="statement"></textarea>
            </div>
          </li>
          <li v-if="standardType==='1'">
            <p class="c-standard-lf-txt"><span class="needed">*</span>标准提案：</p>
            <div class="c-standard-rt-input">
              <Upload style="display: inline-block;" v-on:resetImageName="resetCloudProtocol1" btnText="上传认证公函" accept="image/jpeg,image/png,application/pdf">
                <button class="submit-btn">上传标准提案</button>
              </Upload>
              <a :href="at1path"><span class="download-agreement">下载标准提案模板<img src="../../assets/main/xiazai.png"></span></a>
              <div class="c-business-license">
                <p class="c-tips3">{{attachment1&&attachment1[0].name}}</p>
              </div>
            </div>
          </li>
          <li v-if="standardType==='0'">
            <p class="c-standard-lf-txt"><span class="needed">*</span>标准草案文本：</p>
            <div class="c-standard-rt-input">
              <Upload style="display: inline-block;" v-on:resetImageName="resetCloudProtocol3" btnText="上传认证公函" accept="image/jpeg,image/png,application/pdf">
                <button class="submit-btn">上传标准草案文本</button>
              </Upload>
              <a :href="at3path"><span class="download-agreement">下载标准草案文本模板<img src="../../assets/main/xiazai.png"></span></a>
              <div class="c-business-license">
                <p class="c-tips3">{{attachment3&&attachment3[0].name}}</p>
              </div>
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt"><span class="needed">*</span>标准编制说明：</p>
            <div class="c-standard-rt-input">
              <Upload style="display: inline-block;" v-on:resetImageName="resetCloudProtocol2" btnText="上传认证公函" accept="image/jpeg,image/png,application/pdf">
                <button class="submit-btn">上传标准编制说明</button>
              </Upload>
              <a :href="at2path"><span class="download-agreement">下载标准编制说明模板<img src="../../assets/main/xiazai.png"></span></a>
              <div class="c-business-license">
                <p class="c-tips3">{{attachment2&&attachment2[0].name}}</p>
              </div>
            </div>
          </li>

        </ul>
        <div class="btnbox">
          <button class="cancel-btn" @click="$router.back(-1)">取消</button>
          <button class="submit-btn" @click="createStandard">提交</button>
        </div>
      </div>
    </div>
    <Footer :isLogin="true" />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import CityCascader from '@/components/common/MyCascader/city'
  import Upload from '@/components/common/Upload';
  import {
    MessageBox
  } from 'element-ui';
  import {
    Steps,
    Step
  } from 'element-ui'
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import {
    addStandard
  } from '@/api/standard.js'
  import config from '@/config/index';
  import {
    DatePicker
  } from 'element-ui'
  import {
    validScc,
    validateTelphone,
    validMobile
  } from '@/utils/validTools.js'
  import {
    addProject,
    modifyProject,
    searchproject,
    getProject,
    projectSingup,
    projectSingups,
    deleteMyProject,
    myprojectsignupelist,
    projectcomment
  } from '@/api/project.js'

  import {
    getUserinfo,
  } from '@/api/personalCenter';

  export default {
    name: 'standardcreate',
    components: {
      Header,
      Footer,
      Upload,
      CityCascader,
      [DatePicker.name]: DatePicker,
      [Steps.name]: Steps,
      [Step.name]: Step,
    },
    watch: {
      $route(to, from) {

      }
    },
    mounted() {
      this.queryUserInfo()
    },
    data() {
      return {
        status: 0,
        selActive: 0,
        timelist: ['提案', '立项', '起草', '征求意见', '审查', '批准', '发布'],
        at1path: 'http://img.yunsmartcity.com/tpl/%E6%8F%90%E6%A1%88/2-%E9%A1%B9%E7%9B%AE%E5%BB%BA%E8%AE%AE%E4%B9%A6%E6%A8%A1%E6%9D%BF.doc',
        at2path: 'http://img.yunsmartcity.com/tpl/%E6%8F%90%E6%A1%88/3-%E6%A0%87%E5%87%86%E7%BC%96%E5%88%B6%E8%AF%B4%E6%98%8E%E6%A8%A1%E6%9D%BF.doc',
        at3path: 'http://img.yunsmartcity.com/tpl/%E6%8F%90%E6%A1%88/4-%E6%A0%87%E5%87%86%E8%8D%89%E6%A1%88%E6%96%87%E6%9C%AC%E6%A8%A1%E6%9D%BF.doc',
        uploadUid: '', //标准上传者id
        standardName: '', //标准名称
        stdLevel:'国际',
        organization: '', //组织机构
        legalPerson: '', //法人
        scc: '', //统一信用码
        contacts: '', //联系人
        mobile: '', //手机号
        address: '', //地址
        standardType: '1', //标准类型
        isHaveZl: '', //是否涉及专利
        industryCategory: '新一代信息技术', //技术领域
        productsServices: '', //主要涉及的产品/服务名称
        techDescription: '', //该标准的技术创新点及先进性描述
        valueDescription: '', //该标准在相关产业（产品/服务）中的应用情况及产生的效果
        statement: '', //声明
        taAttachment: [], //提案附件
        attachment1: '',
        attachment2: '',
        attachment3: '',
        orgObj:null,
      }
    },
    computed: {

    },
    methods: {
      queryUserInfo() {
        const {
          uid
        } = getCacheUserInfo();
        this.$http.get(getUserinfo(uid)).then((res) => {
          if (res.code === 1&&res.data&&res.data.org) {
            // debugger
            this.orgObj = res.data.org
            this.organization = this.orgObj.organization
            this.scc = this.orgObj.scc
            this.legalPerson = this.orgObj.legalperson
            this.address = this.orgObj.address
            this.contacts = this.orgObj.contacts
            this.mobile = this.orgObj.mobile
          }else{
            MessageBox.alert('非机构管理员不能创建标准', '需绑定机构管理员', {
              confirmButtonText: '确定',
              callback: action => {
                MessageBox.message({
                  type: 'info',
                  message: `action: ${  this.$router.back(-1)  }`
                });
              }
            });
          }
        });
      },

      getUid() {
        const userInfo = getCacheUserInfo();
        const uid = userInfo && userInfo.uid;
        return uid;
      },
      createStandard() {
        if (!this.standardName) {
          this.$message.error('标准名称不能为空');
          return null;
        }
        if (!this.organization) {
          this.$message.error('组织机构名称不能为空');
          return null;
        }
        if (!this.legalPerson) {
          this.$message.error('法人不能为空');
          return null;
        }
        if (!this.scc) {
          this.$message.error('统一信用码不能为空');
          return null;
        }
        if (!this.contacts) {
          this.$message.error('联系人不能为空');
          return null;
        }
        if (!this.mobile) {
          this.$message.error('手机号不能为空');
          return null;
        }
        if (!validMobile(this.mobile)) {
          this.$message.error('请输入正确的手机号码')
          return null;
        }
        if (!this.address) {
          this.$message.error('地址不能为空');
          return null;
        }
        if (!this.standardType) {
          this.$message.error('标准类型不能为空');
          return null;
        }
        if (!this.isHaveZl) {
          this.$message.error('是否涉及专利不能为空');
          return null;
        }
        if (!this.industryCategory) {
          this.$message.error('技术领域不能为空');
          return null;
        }
        if (!this.productsServices) {
          this.$message.error('主要涉及的产品/服务名称不能为空');
          return null;
        }
        if (!this.techDescription) {
          this.$message.error('技术创新点及先进性不能为空');
          return null;
        }
        if (!this.valueDescription) {
          this.$message.error('应用情况及产生的效果不能为空');
          return null;
        }
        if (!this.statement) {
          this.$message.error('自我声明不能为空');
          return null;
        }
        if(this.standardType==='1'){
          if (this.attachment1.length <= 0 || this.attachment2.length <= 0 ) {
            this.$message.error('请按要求提交全部附件');
            return null;
          }else{
            this.attachment3 = this.attachment1
          }
        }else{
          if (this.attachment2.length <= 0 || this.attachment3.length <= 0) {
            this.$message.error('请按要求提交全部附件');
            return null;
          }else{
             this.attachment1 = this.attachment3
          }
        }

        let params = {
          uploadUid: this.getUid(), //标准上传者id
          standardName: this.standardName, //标准名称
          organization: this.organization, //组织机构
          legalPerson: this.legalPerson, //法人
          scc: this.scc, //统一信用码
          contacts: this.contacts, //联系人
          mobile: this.mobile, //手机号
          address: this.address, //地址
          stdLevel: this.stdLevel,
          standardType: this.standardType, //标准类型
          isHaveZl: this.isHaveZl, //是否涉及专利
          industryCategory: this.industryCategory, //技术领域
          productsServices: this.productsServices, //主要涉及的产品/服务名称
          techDescription: this.techDescription, //该标准的技术创新点及先进性描述
          valueDescription: this.valueDescription, //该标准在相关产业（产品/服务）中的应用情况及产生的效果
          statement: this.statement, //声明
          taAttachment: JSON.stringify([{
            name: this.attachment1[0].name
          }, {
            name: this.attachment2[0].name
          }, {
            name: this.attachment3[0].name
          }]), //提案附件
        }

        // return
        this.$http.post(addStandard(), params).then((res) => {
          if (res.code === 1) {
            this.$message.success('信息提交成功，等待审核');
            this.$router.back(-1)
          }
        });
      },
      resetCloudProtocol1(key) {
        const protocol = [{
          name: key,
        }];
        this.attachment1 = protocol;
      },
      resetCloudProtocol2(key) {
        const protocol = [{
          name: key,
        }];
        this.attachment2 = protocol;
      },
      resetCloudProtocol3(key) {
        const protocol = [{
          name: key,
        }];
        this.attachment3 = protocol;
      },
    }
  }
</script>

<style>
  @import url(./StandardCreate.css);

  .needed {
    color: red;
  }

  .price-negotiation {
    float: left;
  }

  .c-standard-rt-input input.checkbox {
    width: 18px;
    height: 18px;
    margin: 9px;
  }

  .file-btn {
    position: relative;
  }

  .file-btn__upload {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
  }

  .file-btn__upload-btn {
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
  }

  .download-agreement {
    color: #267FF2;
    padding-left: 20px;
    cursor: pointer;
  }

  .download-agreement img {
    vertical-align: 0px;
    margin-left: 7px;
  }

  .c-business-license {
    margin-top: 20px;
  }

  .c-business-license img {
    width: 60px;
    height: auto;
    margin: 0;
  }

  .c-tips3 {
    font-size: 12px;
    line-height: 20px;
    color: #267FF2;
  }

  .el-step__head.is-success {
    color: #0084FF;
    border-color:#0084FF;
  }

  .el-step__line .el-step__line-inner {
    background-color: #0084FF;
  }

  .el-step__icon.is-text {
    border-color: #0084FF;
  }

  .el-step__title.is-success {
    color: #0084FF;
  }

  .el-step__icon-inner {
    color: #0084FF;
  }

  .el-step__title.is-process {
    color: #2981F2;
  }

  .el-step__head.is-wait .el-step__icon.is-text {
    border-color: #C0C4CC;
  }

  .el-step__head.is-wait .el-step__icon.is-text .el-step__icon-inner {
    color: #C0C4CC;
  }
</style>
